import { window } from '../../globals';
import useToastedMutation from '../../ReactQuery/useToastedMutation';
import { post } from '../../redux/api';

async function markOnboardingComplete() {
  return post<void, void>('/api/user/onboarding-complete', undefined);
}

function markLocallyComplete() {
  if (window.user) {
    window.user.onboardingSurveyCompletedAt = new Date();
  }
}

/**
 * Marks the user as having completed the onboarding survey. Writes
 * `window.user.onboardingSurveyCompletedAt` locally on both success AND error:
 * PostHog already has the user's responses by the time this mutation fires,
 * so re-prompting on a server failure gains no data and only traps the user
 * in a per-page-load loop. The error toast surfaces the failure.
 */
export function useOnboardingComplete() {
  return useToastedMutation({
    mutationFn: markOnboardingComplete,
    errorToastMessage: 'Couldn\'t save your onboarding response — please contact support if this keeps happening.',
    onSuccess: markLocallyComplete,
    onError: markLocallyComplete,
  });
}
